<app-tool-loader [isLoading]="isLoading()" positionUnset="true">
  <app-operation-envelope-toolbar
    class="flex-shrink-0"
    [singleMultiple]="singleMultiple"
    [resultsDisplay]="resultsDisplay"
    [envelopeOperation]="envelopeOperation"
    [selectedSingleMultiple]="selectedSingleMultiple()"
    [selectedResultsDisplay]="selectedResultsDisplay()"
    [selectedEnvelopeOperation]="selectedEnvelopeOperation()"
    [phaseEnvelopes]="phaseEnvelopes()"
    [selectedPhaseEnvelope]="selectedPhaseEnvelope()"
    [operations]="operations()"
    [selectedOperation]="selectedOperation()"
    [moveUpDisabled]="moveUpDisabled()"
    [moveDownDisabled]="moveDownDisabled()"
    (modeChanged)="modeToggle($event)"
    (phaseEnvelopeChanged)="onPhaseEnvelopeSelected($event)"
    (resultsDisplayChanged)="onSelectedResultsDisplayUpdated($event)"
    (envelopeOperationChanged)="selectedTableChange($event)"
    (operationChanged)="onOperationSelected($event)"
    (moveRequested)="onUpDownButtonClick($event)"
  ></app-operation-envelope-toolbar>

  <app-operation-envelope-results
    class="flex-1 min-h-0"
    [selectedSingleMultiple]="selectedSingleMultiple()"
    [selectedResultsDisplay]="selectedResultsDisplay()"
    [tableName]="tableName"
    [resultsGrid]="resultsGrid"
    [cols]="cols"
    [plotData]="plot.data"
    [xAxisTitle]="xAxisTitle"
    [yAxisTitle]="yAxisTitle"
    [plotName]="plotName"
    [downloadPlotName]="downloadPlotName"
    [operationEnvelopeStore]="operationEnvelopeStore"
  ></app-operation-envelope-results>

  <p-dialog [draggable]="false" [(visible)]="needToCalculate" [closable]="false" appendTo="self">
    <i class="pi pi-exclamation-circle pr-1"></i>
    <label>{{ calculationError }}</label>
    <br />
    <br />
  </p-dialog>

</app-tool-loader>